const form = document.getElementById("loginForm");
const msg = document.getElementById("msg");

form.addEventListener("submit", async (e) => {
  e.preventDefault();

  // extract values from the form inputs
  const email = form.email.value.trim();
  const password = form.password.value;

  // clear msg
  msg.textContent = "";

  try {
    // send a POST
    const res = await fetch("/api/login", {
      method: "POST",
      headers: {
        // aplication as json format
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
      // tells the browser to include cookies in cross-origin/same-origin requests
      credentials: "include",
    });

    let data = {};
    try {
      data = await res.json();
    } catch (err) {
      console.log("Fehler", err);
    }

    // hheck if server confirmed a successful login
    if (res.ok && data.success) {
      window.location.href = data.redirect;
    } else {
      msg.textContent = "❌ " + (data.error || "Login failed");
    }
  } catch (err) {
    console.error(err);
    msg.textContent = "Connection error.";
  }
});
